<template>
  <v-alert dense outlined type="error">
    {{ negalimaText }}
  </v-alert>
</template>

<script>
export default {
  name: 'ElRoleNegalima',
  props: {
    text: String,
  },
  computed: {
    negalimaText() {
      return this.text ?? 'Neturite teisių atlikti šį veiksmą'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
